import { css } from '@emotion/react';

import type { SerializedStyles } from '@emotion/react';

type SafeAreaDirection = 'top' | 'bottom';

/**
 * iOS safe area inset을 padding으로 적용하는 CSS 유틸
 * @description viewport-fit=cover 사용 시 노치/홈바 영역 대응
 * @example
 * // 상하 모두 적용
 * css={safeArea('top', 'bottom')}
 *
 * // 하단만 적용
 * css={safeArea('bottom')}
 */
export function safeArea(...directions: SafeAreaDirection[]): SerializedStyles {
  const rules = directions.map(dir => `padding-${dir}: env(safe-area-inset-${dir});`).join('\n');

  return css`
    ${rules}
  `;
}
